import { Grid } from "@material-ui/core";
import React from "react";
import { getShipBackText, gridClasses } from "./helpers";

const ShipBackTrackingCode = (props) => {
  const { trackingCode } = props;

  if (!trackingCode) {
    return null;
  }

  return (
    <div className="shipBack--card shipBack--card-secondary shipBack--card-tracking">
      <Grid container classes={gridClasses}>
        <Grid item xs={12} classes={gridClasses}>
          <h2 className="shipBack--subheader">
            {getShipBackText("trackYourShipment")}
          </h2>
        </Grid>
        <Grid item xs={12} classes={gridClasses}>
          <p className="shipBack--text" style={{ marginTop: 15 }}>
            {getShipBackText("trackYourShipmentText")}
            {` #${trackingCode}, `}
            <a
              href={`https://www.fedex.com/fedextrack/?tracknumbers=${trackingCode}`}
              target="_blank"
            >
              here
            </a>
            .
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default ShipBackTrackingCode;
